import { Text, theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';

import { pressContent } from 'assets/content/homeV2';

import useResponsiveVariant from 'utils/useResponsiveVariant';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['8x']};
  width: 100%;
  padding: 50px 20px;

  ${legacyTheme.breakpoints.up('md')} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 50px 68px;
  }
`;

const LogoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 40px;
  width: 100%;

  ${legacyTheme.breakpoints.up('md')} {
    display: flex;
    gap: 40px;
    width: unset;
  }

  ${legacyTheme.breakpoints.up('lg')} {
    gap: 100px;
  }
`;

const PressLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const PressLogo = styled(Image)`
  max-height: 22px;
  width: auto;
`;

export const Press = () => {
  const { isMobile } = useResponsiveVariant();
  return (
    <Container data-testid="home-revamp-press">
      <Text
        as="h2"
        color="primary.300"
        textAlign="center"
        variant={isMobile ? 'labelSm' : 'labelMd'}
      >
        {pressContent.title}
      </Text>
      <LogoGrid>
        {pressContent.images[isMobile ? 'mobile' : 'desktop'].map((pressImage) => (
          <PressLogoContainer key={pressImage.alt}>
            <PressLogo alt={pressImage.alt} src={pressImage.src} />
          </PressLogoContainer>
        ))}
      </LogoGrid>
    </Container>
  );
};
